module.exports = __webpack_public_path__ + "static/media/r40.a7da405a.jpg";